module.exports = __webpack_public_path__ + "static/media/chatSending.970a827b.svg";